import { render, staticRenderFns } from "./PenyebranganDetail.vue?vue&type=template&id=685503b4&scoped=true"
import script from "./PenyebranganDetail.vue?vue&type=script&lang=js"
export * from "./PenyebranganDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685503b4",
  null
  
)

export default component.exports